import { ComponentStyleProps } from "../../../lib/styles/props/component-style-props";
import React from "react";
import {
  Box,
  ComponentMultiStyleConfig,
  Link,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { CommentHeaderContent } from "../types";
import { CMDatetimeText } from "../../text";
import { hasValue } from "../../../lib/util/common-util";
import { Link as RouterLink } from "react-router-dom";

export type CMCommentHeaderProps = {
  /**
   * 表示用のデータ
   */
  headerContent: CommentHeaderContent[];
  date?: Date;
} & ComponentStyleProps;

/**
 * タイトルと名称を複数件表示する。
 * 名称に対して、urlリンクを設定することが可能。
 */
export const CMCommentHeader = ({
  headerContent,
  date,

  sx,
  ...rest
}: CMCommentHeaderProps) => {
  const styles = useMultiStyleConfig("CMCommentHeaderStyles");

  /**
   * 区切り文字が指定されていない場合は、デフォルト値を設定
   * @param sep 区切り文字
   */
  const separator = (sep?: string) => {
    return hasValue(sep) && sep !== "" ? sep : ":";
  };

  /**
   * 表示内容が指定されていない場合は、デフォルト値を設定
   * @param val 表示内容
   */
  const value = (val?: string) => {
    return hasValue(val) && val !== "" ? val : "-";
  };

  return (
    <Box sx={{ ...styles.container, ...sx }} {...rest}>
      {headerContent.map((content, index) => (
        // 関連情報を出力するエリア
        <Box key={index} sx={styles.relationArea}>
          <Text sx={styles.label}>{content.label}</Text>
          <Text sx={styles.separator}> {separator(content.separator)}</Text>

          {/*urlが設定されている場合はリンク形式で表示*/}
          {hasValue(content.url) ? (
            <Link as={RouterLink} to={content.url} isExternal sx={styles.url}>
              {value(content.value)}
            </Link>
          ) : (
            <Text sx={styles.value}>{value(content.value)}</Text>
          )}
        </Box>
      ))}
      <CMDatetimeText value={date} sx={styles.date} />
    </Box>
  );
};

export const CMCommentHeaderStyles: ComponentMultiStyleConfig = {
  parts: [
    "container",
    "relationArea",
    "label",
    "separator",
    "url",
    "value",
    "date",
  ],
  baseStyle: {
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      fontSize: "14px",
      color: "gray.500",
    },
    relationArea: {
      flex: "0 1 auto",
      minW: 0,

      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      width: "fit-content",
      marginRight: "12px",
    },
    label: {
      flex: "0 0 auto",

      fontSize: "12px",
    },
    separator: {
      flex: "0 0 auto",

      marginLeft: "2px",
      marginRight: "6px",
      fontSize: "12px",
    },

    url: {
      flex: "1 1 auto",

      marginRight: "4px",
      color: "blue.600",

      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    value: {
      flex: "1 1 auto",

      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    date: {
      flex: "0 0 max-content",
      marginLeft: "auto",
    },
  },
};
